import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RakutenLoader from '../components/RakutenLoader.jsx';
import RakutenApp from './RakutenApp.jsx';

class RakutenAuth extends Component {
    static propTypes = {
        dispatch: PropTypes.func,
        i18nLoaded: PropTypes.bool,
        shopId: PropTypes.string,
        externalShopId: PropTypes.string,
        shopName: PropTypes.string,
        merchantDashAllowed: PropTypes.bool,
        isReadOnlyUser: PropTypes.bool,
        advertisableEid: PropTypes.string,
        finishedLoadingNotifications: PropTypes.bool,
        notifications: PropTypes.array,
        finishedLoadingStrategy: PropTypes.bool,
        strategy: PropTypes.object,
        aggregatePerformance: PropTypes.object,
        monthToDatePerformance: PropTypes.object,
        runMonthlyBudgetCapValidation: PropTypes.bool,
        dailyPerformance: PropTypes.array,
        isRecommendedBudgetDisplayed: PropTypes.bool
    };

    render() {
        const { i18nLoaded, shopId, advertisableEid, finishedLoadingStrategy, finishedLoadingNotifications } = this.props;
        if (i18nLoaded === false || shopId === null || advertisableEid === null || finishedLoadingStrategy === false || finishedLoadingNotifications === false) {
            return (
                <div>
                    <RakutenLoader className='auth-loader' />
                </div>
            );
        }
        return <RakutenApp { ...this.props } />;
    }


}
;

function mapStateToProps(state) {
    return {
        i18nLoaded: state.i18nLoaded,
        shopId: state.shopId,
        shopName: state.shopName,
        externalShopId: state.externalShopId,
        merchantDashAllowed: state.merchantDashAllowed,
        isReadOnlyUser: state.isReadOnlyUser,
        advertisableEid: state.advertisableEid,
        finishedLoadingNotifications: state.finishedLoadingNotifications,
        notifications: state.notifications,
        finishedLoadingStrategy: state.finishedLoadingStrategy,
        strategy: state.strategy,
        aggregatePerformance: state.aggregatePerformance,
        monthToDatePerformance: state.monthToDatePerformance,
        runMonthlyBudgetCapValidation: state.runMonthlyBudgetCapValidation,
        dailyPerformance: state.dailyPerformance,
        reportingStartDate: state.reportingStartDate,
        reportingEndDate: state.reportingEndDate,
        reportingSort: state.reportingSort,
        showSaveModal: state.showSaveModal,
        dailyAttributions: state.dailyAttributions,
        aggregateAttributions: state.aggregateAttributions,
        recommendedBudget: state.recommendedBudget,
        isRecommendedBudgetDisplayed: state.isRecommendedBudgetDisplayed
    };
}

export default connect(mapStateToProps)(RakutenAuth);
